import {useMantineTheme} from '@mantine/core';
import React from 'react';
import {EdgeProps} from 'reactflow';

import {FlowchartEditorModeContext} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/FlowchartEditorModeContext';
import {FlowchartEditorMode} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/ProcessFlowchartEditorModeConstants';
import BaseEdgeRenderer from 'ui-library/reactflow/edges/BaseEdgeRenderer';
import {ReactFlowLockedContext} from 'ui-library/reactflow/LockedContext';

import {getEdgeStatus} from './edgeUtils';
import RemoveEdgeLabel from './RemoveEdgeLabel';

export default function TaskSchemaControlFlowEdge(props: EdgeProps): JSX.Element {
  const locked = ReactFlowLockedContext.useContext() ?? false;
  const editorMode = FlowchartEditorModeContext.useContext();
  const isReadOnly = locked || editorMode === FlowchartEditorMode.EXECUTION_VIEWER;
  const theme = useMantineTheme();

  return (
    <>
      <BaseEdgeRenderer
        {...props}
        data={{
          ...props.data,
          hoverColor: isReadOnly ? undefined : theme.colors.blue[4],
          status: getEdgeStatus(props),
        }}
      />
      {props.selected && !locked && <RemoveEdgeLabel {...props} />}
    </>
  );
}
